<template>
    <div v-if="state">
        <div class="hidden lg:block py-6">
            <div class="container flex flex-wrap justify-center max-w-screen-lg">
                <button
                    v-for="item in mergeCategories"
                    :key="item.value"
                    class="my-2 btn-small"
                    :class="{ 'btn-small-active': item.isRefined }"
                    @click="state.refine(item.value)"
                >
                    {{ item.label }}
                </button>
            </div>
        </div>

        <!-- Mobile -->
        <div
            class="lg:hidden container ais-search-mobile-categories absolute transition-transform duration-200 transform translate-x-full bg-white w-full z-10 py-12"
        >
            <button
                class="flex items-center justify-between w-full px-4 py-2 text-blue-500 tracking-wide text-sm tracking-medium font-semibold bg-bluegrey focus:outline-none"
                :class="filterActive ? 'rounded-t-3' : 'rounded-3'"
                @click="filterActive = !filterActive"
            >
                <span>{{ currentlyRefined.label }}</span>
                <div class="w-4 h-4 flex justify-center items-center">
                    <svg
                        width="12"
                        height="8"
                        viewBox="0 0 12 8"
                        :class="
                            filterActive ? 'transform transition-all rotate-180' : 'transition-all'
                        "
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M10.6377 2.06941L10.9912 2.42296L11.3448 2.06941L10.9912 1.71586L10.6377 2.06941ZM10.2841 2.42296L9.93059 2.06941H9.93059L10.2841 2.42296ZM9.93059 1.3623L10.2841 1.00875L9.93059 0.655198L9.57704 1.00875L9.93059 1.3623ZM9.57704 1.71586L9.93059 2.06941L9.57704 1.71586ZM5.99955 5.29334L5.646 5.64689L5.99955 6.00045L6.35311 5.64689L5.99955 5.29334ZM2.42207 1.71586L2.77563 1.3623V1.3623L2.42207 1.71586ZM2.06852 1.3623L2.42207 1.00875L2.06852 0.655198L1.71497 1.00875L2.06852 1.3623ZM1.36141 2.06941L1.00786 1.71586L0.654306 2.06941L1.00786 2.42296L1.36141 2.06941ZM1.71497 2.42296L1.36141 2.77652V2.77652L1.71497 2.42296ZM5.57704 6.28503L5.93059 5.93148L5.57704 6.28503ZM5.93059 6.63859L5.57704 6.99214L5.93059 7.34569L6.28414 6.99214L5.93059 6.63859ZM5.99955 6.56962L6.35311 6.21607L5.99955 5.86251L5.646 6.21607L5.99955 6.56962ZM6.06852 6.63859L5.71497 6.99214L6.06852 7.34569L6.42207 6.99214L6.06852 6.63859ZM6.42207 6.28503L6.06852 5.93148L6.42207 6.28503ZM10.2841 1.71586L9.93059 2.06941L10.6377 2.77652L10.9912 2.42296L10.2841 1.71586ZM9.57704 1.71586L10.2841 2.42296L10.9912 1.71586L10.2841 1.00875L9.57704 1.71586ZM9.93059 2.06941L10.2841 1.71586L9.57704 1.00875L9.22348 1.3623L9.93059 2.06941ZM6.35311 5.64689L9.93059 2.06941L9.22348 1.3623L5.646 4.93979L6.35311 5.64689ZM6.35311 4.93979L2.77563 1.3623L2.06852 2.06941L5.646 5.64689L6.35311 4.93979ZM2.77563 1.3623L2.42207 1.00875L1.71497 1.71586L2.06852 2.06941L2.77563 1.3623ZM1.71497 1.00875L1.00786 1.71586L1.71497 2.42296L2.42207 1.71586L1.71497 1.00875ZM1.00786 2.42296L1.36141 2.77652L2.06852 2.06941L1.71497 1.71586L1.00786 2.42296ZM1.36141 2.77652L5.22348 6.63859L5.93059 5.93148L2.06852 2.06941L1.36141 2.77652ZM5.22348 6.63859L5.57704 6.99214L6.28414 6.28503L5.93059 5.93148L5.22348 6.63859ZM6.28414 6.99214L6.35311 6.92317L5.646 6.21607L5.57704 6.28503L6.28414 6.99214ZM6.42207 6.28503L6.35311 6.21607L5.646 6.92317L5.71497 6.99214L6.42207 6.28503ZM6.06852 5.93148L5.71497 6.28503L6.42207 6.99214L6.77563 6.63859L6.06852 5.93148ZM9.93059 2.06941L6.06852 5.93148L6.77563 6.63859L10.6377 2.77652L9.93059 2.06941Z"
                            fill="#5D83BF"
                        />
                    </svg>
                </div>
            </button>

            <div v-if="filterActive" class="w-full rounded-b-3 overflow-hidden bg-white">
                <a
                    v-for="item in mergeCategories"
                    :key="item.value"
                    class="flex items-center justify-between border-b border-white border-opacity-75 w-full px-4 py-4 tracking-wide font-heading text-sm tracking-medium font-semibold transition-all hover:bg-blue-500 hover:text-white uppercase last:border-0"
                    :class="isRefined ? 'text-white bg-blue-500' : 'bg-bluegrey text-blue-500'"
                    @click="
                        state.refine(item.value);
                        filterActive = false;
                    "
                >
                    <span>{{ item.label }}</span>
                </a>
            </div>

            <div
                v-if="
                    currentlyRefined &&
                    currentlyRefined.children &&
                    currentlyRefined.children.length
                "
                class="container mt-8 flex overflow-x-auto subitem-wrapper text-sm text-grey-300"
            >
                <a
                    v-for="subitem in getSubItems(state.items)"
                    :key="subitem.value"
                    class="px-4 cursor-pointer hover:text-teal-600"
                    @click="state.refine(subitem.value)"
                >
                    <span
                        class="inline-block pb-4 whitespace-no-wrap"
                        :class="[subitem.isRefined ? 'text-blue-600' : '']"
                    >
                        {{ subitem.label }}
                    </span>
                </a>
            </div>
        </div>

        <!-- End Mobile -->
        <div class="container hidden lg:block">
            <div
                v-if="
                    currentlyRefined &&
                    currentlyRefined.children &&
                    currentlyRefined.children.length
                "
                class="flex flex-wrap justify-center text-sm text-grey-300"
            >
                <a
                    v-for="subitem in getSubItems(state.items)"
                    :key="subitem.value"
                    class="px-4 cursor-pointer hover:text-blue-500 font-medium"
                    @click="state.refine(subitem.value)"
                >
                    <span
                        class="inline-block pb-4 whitespace-no-wrap"
                        :class="[subitem.isRefined ? 'text-blue-500' : '']"
                    >
                        {{ subitem.label }}
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { createWidgetMixin } from 'vue-instantsearch';
import { connectHierarchicalMenu } from 'instantsearch.js/es/connectors';

export default {
    mixins: [createWidgetMixin({ connector: connectHierarchicalMenu })],

    data() {
        return {
            filterActive: false
        };
    },

    computed: {
        widgetParams() {
            return {
                attributes: ['roam_products_categories.lvl0', 'roam_products_categories.lvl1']
            };
        },

        mergeCategories() {
            const noneRefined = !this.state.items.find((item) => item.isRefined);

            const result = this.$root.categories.map((cat) => {
                const match = this.state.items.find((item) => item.label === cat.label);
                let isRefined = match ? match.isRefined : false;

                if (cat.label === 'All') isRefined = noneRefined;

                return {
                    ...cat,
                    isRefined
                };
            });

            return result;
        },

        currentlyRefined() {
            return this.mergeCategories.find((cat) => cat.isRefined);
        }
    },

    methods: {
        getSubItems(items) {
            const refined = items.find((item) => item.isRefined);
            return refined ? refined.data : null;
        }
    }
};
</script>

<style scoped>
.subitem-wrapper {
    &::before,
    &::after {
        margin: auto;
        content: '';
    }
}
</style>
